// Contractor and client portal sessions end after 2 hours without activity or
// 12 hours after sign-in (pen test AD25996 / AD26341, AD8). When one ends, the
// server's 401 (or the /me probe) says so with `session_ended`. Every portal
// fetch helper passes its failures through here, and the portal shells listen
// for the event and return to the sign-in screen with the message, rather than
// leaving the person on a screen whose requests now quietly fail.
export const SESSION_ENDED_EVENT = 'av-portal-session-ended';

export function noteSessionEnded(status, data) {
  if (status !== 401 || !data?.session_ended || typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(SESSION_ENDED_EVENT, { detail: data.error || data.message || '' }));
}

/** The sign-in notice from a /me probe, or '' when the person simply is not signed in. */
export const endedNotice = (me) => (me?.authenticated === false && me.session_ended ? (me.message || '') : '');
